
import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";
// GeneralViews
import NotFound from "@/pages/NotFoundPage.vue";
import Logout from "@/pages/Logout.vue";
import Authen from "@/pages/Authen.vue";
import Callback from "@/pages/Callback.vue";
import Campaign from "@/pages/Campaign.vue";
import CampaignEnded from "@/pages/CampaignEnded.vue";
import InsufficientConditions from "@/pages/InsufficientConditions.vue";
import RetriedCampaign from "@/pages/RetriedCampaign.vue";
import JoinedCampaign from "@/pages/JoinedCampaign.vue";
import Game from "@/pages/Game.vue";
import GameWin from "@/pages/GameWin.vue";
import GameLose from "@/pages/GameLose.vue";
import Prize from "@/pages/Prize.vue";
import PrizeDetail from "@/pages/PrizeDetail.vue";
const routes = [
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/campaign",
    children: [
      {
        path: "logout",
        name: "Logout",
        component: Logout
      },
      {
        path: 'campaign',
        name: 'Authen',
        component: Authen
      },
      {
        path: 'callback',
        name: 'Callback',
        component: Callback
      },
      {
        path: 'main',
        name: 'Campaign',
        component: Campaign
      },
      {
        path: "campaign-ended",
        name: "Ended",
        component: CampaignEnded,
      },
      {
        path: "insufficient-conditions",
        name: "Insufficient conditions",
        component: InsufficientConditions,
      },
      {
        path: "retried-campaign",
        name: "Retried",
        component: RetriedCampaign
      },
      {
        path: "joined-campaign",
        name: "Joined",
        component: JoinedCampaign
      },
      {
        path: "game",
        name: "Game",
        component: Game
      },
      {
        path: "game-win",
        name: "Win",
        component: GameWin
      },
      {
        path: "game-lose",
        name: "Lose",
        component: GameLose
      },
      {
        path: "prize",
        name: "Prize",
        component: Prize
      },
      {
        path: "prize-detail",
        name: "Detail",
        component: PrizeDetail
      }
    ]
  },
  { path: "*", component: NotFound, name: "Error" }
];

export default routes;

